angular.module("dx.webapp.forgotPassword", [
	"digiexam.services",
	"digiexam.services.faults",
	"dx.webapp.navigation",
	"dx.webapp.validation",

	"dx.ui.utils",
	"dx.ui.components.dialog",
	"dx.ui.components.localize",

	"ngRoute",
]);
